module.exports = __webpack_public_path__ + "static/media/checklist.fef71229.svg";